goog.provide('el8.app.settings.staffGroups');

goog.require('el8.appshared.listeditorOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.staffGroups');
goog.require('el8.template.app.settings.staffGroups');
goog.require('el8.uiwidget.CuratedList');
goog.require('el8.util.consts');


el8.app.settings.staffGroups = (function() {

    var that;

    that = {

        init: function($container) {

            // create initial frame
            var $content = $(el8.template.app.settings.staffGroups.content({
            }));
            $container.html($content).show();

            setupStaffGroupList($container);
        }

    };

    function setupStaffGroupList($container) {

        var curatedList;

        var mrOpts = $.extend(el8.appshared.mindreaderOpts.practiceUsers(), {
            formatSelected: function(item) { return null; },
            selectFn: function(event, item) {
                var userLe = curatedList.getForm().getListeditor('users');
                userLe.addEntry(item);
            }
        });
        var leOpts = $.extend(el8.appshared.listeditorOpts.practiceUsers(), {
            list: function() { return $('.group-member-list', $container); },
            mindreaderOpts: mrOpts
        });

        curatedList = new el8.uiwidget.CollapsibleCuratedList({
            entitySet: el8.data.staffGroups,
            customDeleteFn: function(group) {
                var confirmMsg = "Are you sure you want to permanently delete this staff group? " +
                                 "(Note: this group will also be removed from any patient " +
                                 "passport message routes it is currently part of and any staff delegate " +
                                 "associated with this group will be deleted as well.)";
                el8.uiwidget.confirm(confirmMsg, function() { el8.data.staffGroups.deleteItem(group); }, null, {prefHeight: 275});
            },
            itemDescriptionStr: 'staff group',
            container: $('.staff-group-section', $container),
            listSelector: '.staff-group-list',
            sortable: false,
            listTemplateFn: function() {
                return el8.template.app.settings.staffGroups.list({
                    staffGroups: el8.data.staffGroups.allAsSoyMaps()
                });
            },
            saveFn: saveStaffGroup,
            formTemplateFn: el8.template.app.settings.staffGroups.form,
            formPopulateFn: function(form, staffGroup) {
                form.setVal('name', staffGroup.getName());
                if (staffGroup.getUserIds()) {
                    var userLe = curatedList.getForm().getListeditor('users');
                    staffGroup.getActiveMembers().forEach(function(u) {
                        userLe.addEntry(u);
                    });
                }
            },
            fieldSpec: [
                {
                    name: 'name',
                    selector: ':input[name="name"]',
                    infoText: 'New staff group name',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 50,
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'users',
                    selector: ':input[name="users"]',
                    infoText: 'Add provider or staff in practice...',
                    maxLength: 100,
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    newMindreader: true,
                    listeditorOpts: leOpts
                }
            ]
        });
        curatedList.init();

    }

    function saveStaffGroup(form, $elem) {
        if (!validationFn(form)) { return; }

        var staffGroup;
        var elemId = $elem.data('id');
        if (elemId) {
            staffGroup = el8.data.staffGroups.getById(elemId);
        } else {
            staffGroup = el8.data.staffGroups.create({}, true); // noNotify: re-render when saved
        }

        staffGroup.setName(form.getVal('name'));
        var userLe = form.getListeditor('users');
        var userIds = _.map(_.pluck(userLe.getAllEntries(), 'id'), function(id) { return parseInt(id, 10); });
        staffGroup.setUserIds(userIds);

        var data = staffGroup.asMap(true, false);
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('staffGroups', [staffGroup.getId()]),
            data: JSON.stringify(data),
            success: function(data) {
                el8.data.staffGroups.create(data);
            },
            error_msg: function(status, defaultMsg) {
                if (status === 409) {
                    el8.uiwidget.alert('This staff group already exists. ' +
                        'Please edit the existing group named "'+staffGroup.getName() +
                        '" or pick a new name.');
                } else {
                    el8.uiwidget.alert(defaultMsg);
                }
            }
        });
    }

    function validationFn(form) {
        if (!form.isValid()) { return false; }
        var userLe = form.getListeditor('users');
        var userEntries = userLe.getAllEntries();
        var userIds = _.map(_.pluck(userEntries, 'id'), function(id) { return parseInt(id, 10); });
        if (!userEntries.length) {
            el8.uiwidget.alert("Please add at least one group member.");
            return false;
        }
        for (var i=0; i<userIds.length; i++) {
            if (!userIds[i]) {
                el8.uiwidget.alert('"'+userEntries[i].text+'" is not valid group member - please select from autocomplete.');
                return false;
            }
        }

        return true;
    }


    return that;

})();